import { set } from "@/utils/vuex";

export default {
  setPending: set("pending"),
};
